module.exports = __webpack_public_path__ + "img/co-branded-logo.59d3f97e.svg";